export default __webpack_public_path__ + "static/media/Avacado Seeds.95aadd02.PNG";